import { FC, useState } from 'react';
import { IconNames } from 'components/Icon';
import { showToast } from 'components/Toast';
import { copyToClipboard } from 'helpers/clipboard';
import { DashboardScreen, trackEvent } from 'helpers/mixpanelEvents';
import { BadgeCtaCard } from './BadgeCtaCard';
import { ShareScorePopup } from './ShareScorePopup';

const SCREEN: DashboardScreen = 'recipients_dashboard';

interface ShareScoreCtaProps {
  impactScore: number;
  fundraisingUrl: string;
  badgeYear: string;
  refParam: string;
}

export const ShareScoreCta: FC<ShareScoreCtaProps> = ({
  impactScore,
  fundraisingUrl,
  badgeYear,
  refParam,
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const trackedUrl = `${fundraisingUrl}${refParam}`;
  const shareText = `My Oath Impact Score is ${impactScore.toFixed(1)}/10 - meaning I'm a top race of ${badgeYear}! Oath rates candidates based on overall competitiveness, stakes, and financial need. You can support my campaign here: ${trackedUrl}`;

  const handleOpen = () => {
    trackEvent('Share Score Popup Opened', { screen: SCREEN });
    setIsPopupOpen(true);
  };

  const handleCopy = () => {
    copyToClipboard(shareText)
      .then(() => {
        trackEvent('Share Text Copied', { screen: SCREEN });
        showToast('Copied! Paste it into your post.', 'success');
      })
      .catch(() => showToast('Failed to copy text. Please copy it manually.', 'error'));
  };

  const handlePlatformSelect = (platform: 'x_twitter' | 'facebook' | 'instagram') => {
    trackEvent('Share Score Platform Selected', { screen: SCREEN, platform });
    handleCopy();
  };

  return (
    <>
      <BadgeCtaCard
        icon={IconNames.Export}
        title="Share your score"
        description="Pre-filled post for Instagram, X, or Facebook."
        action={
          <button
            type="button"
            className="btn-inkBlue btn btn-secondary"
            onClick={handleOpen}
            aria-label="Open the share text popup"
          >
            <span className="body-small-text text-white">Share Now</span>
          </button>
        }
      />
      <ShareScorePopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        shareText={shareText}
        trackedUrl={trackedUrl}
        onCopy={handleCopy}
        onPlatformSelect={handlePlatformSelect}
      />
    </>
  );
};
